const exibivel = (v) => v >= 1;

export const valoresExibiveis = (arr = []) => arr.map((v) => (exibivel(v) ? v : null));

export const semItensVazios = (labels = [], series = []) => {
  const indices = labels
    .map((_, i) => i)
    .filter((i) => series.some((serie) => exibivel(serie[i])));

  return {
    labels: indices.map((i) => labels[i]),
    series: series.map((serie) => indices.map((i) => (exibivel(serie[i]) ? serie[i] : null))),
  };
};

const eixos = {
  vertical: {
    tamanho: (el) => el.base - el.y,
    esticar: (el, delta) => {
      el.y -= delta;
    },
    deslocar: (el, delta) => {
      el.base -= delta;
      el.y -= delta;
    },
  },
  horizontal: {
    tamanho: (el) => el.x - el.base,
    esticar: (el, delta) => {
      el.x += delta;
    },
    deslocar: (el, delta) => {
      el.base += delta;
      el.x += delta;
    },
  },
};

export const pluginBarraMinima = (id, minimo, orientacao = "vertical") => {
  const eixo = eixos[orientacao];

  const temBarra = (chart, dsIndex, i) =>
    !chart.getDatasetMeta(dsIndex).hidden &&
    chart.data.datasets[dsIndex].data[i] > 0 &&
    chart.getDatasetMeta(dsIndex).data[i];

  return {
    id,
    beforeDatasetsDraw(chart) {
      chart.data.datasets.forEach((dataset, dsIndex) => {
        dataset.data.forEach((_, i) => {
          const el = temBarra(chart, dsIndex, i);
          if (!el) return;

          const delta = minimo - eixo.tamanho(el);
          if (delta <= 0) return;

          eixo.esticar(el, delta);
          for (let acima = dsIndex + 1; acima < chart.data.datasets.length; acima += 1) {
            const elAcima = temBarra(chart, acima, i);
            if (elAcima) eixo.deslocar(elAcima, delta);
          }
        });
      });
    },
  };
};
